import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

/**
 * Códigos dos módulos ATIVOS da prefeitura (legível sem login). Usado para o portal
 * público esconder opções de módulos desativados. Enquanto carrega, retorna null
 * (chamadores devem tratar null como "ainda não sei" e, na dúvida, mostrar tudo).
 */
export function useModulosAtivos(): Set<string> | null {
  const [ativos, setAtivos] = useState<Set<string> | null>(null);

  useEffect(() => {
    let vivo = true;
    supabase.rpc('modulos_ativos_publico').then(({ data }) => {
      if (!vivo) return;
      setAtivos(new Set((data ?? []) as string[]));
    });
    return () => { vivo = false; };
  }, []);

  return ativos;
}
